// extracted by mini-css-extract-plugin
export default {"newChatStack":"NewChat_newChatStack__sRSZ+","newChatButton":"NewChat_newChatButton__5eYYZ","newChatIcon":"NewChat_newChatIcon__WdNIX"};